<template>
  <div style="background:#fff">
    <div>
      <div style="padding: 30px 0 0 30px;font-size: 16px;font-weight: 600;color: #333;">
        运营信息
      </div>
      <div style="display: flex;justify-content: space-around;">
        <div style="width:200px;height:200px;padding:20px">
          <img :src="listNum.headPath">
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-around;">
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              人员角色
            </div>
            <a-input v-model="listNum.userType" placeholder="Basic usage" />
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              人员姓名
            </div>
            <a-input v-model="listNum.realName" placeholder="Basic usage" />
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              手机号
            </div>
            <a-input v-model="listNum.mobile" placeholder="Basic usage" />
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              门禁卡号
            </div>
            <a-input v-model="listNum.cardNo" placeholder="Basic usage" />
          </div>
          <div style="width:40%;margin:10px 0">
            <div>省市区</div>
            <a-input v-model="listNum.provinceName" placeholder="Basic usage" style="width:50%" />
            <a-input v-model="listNum.cityName" placeholder="Basic usage" style="width:40%" />
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              具体地址
            </div>
            <a-input v-model="name" placeholder="Basic usage" />
          </div>
          <div style="width:100%">
            <div v-for="(list,index) in listNum.creditCardInfoList" :key="index" style="display: flex;    justify-content: space-around;">
              <div v-if="list.productName" style="width:40%;margin:10px 0">
                <div class="boy_top">
                  管辖点位
                </div>
                <a-input v-model="list.productName" placeholder="Basic usage" />
              </div>
              <div v-if="list.creditCardTime" style="width:40%;margin:10px 0">
                <div class="boy_top">
                  最新刷卡时间
                </div>
                <a-input v-model="list.creditCardTime" placeholder="Basic usage" />
              </div>
            </div>
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              行为照片
            </div>
            <div style="width:300px;height:auto">
              <img :src="listNum.creditCardImg">
            </div>
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
            </div>
            <div style="width:300px;height:auto">
              <!-- <img :src="listNum.creditCardImg"> -->
            </div>
          </div>
          <!-- <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              管辖点位
            </div>
            <a-input placeholder="Basic usage" />
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              最新刷卡时间
            </div>
            <a-input placeholder="Basic usage" />
          </div>
          <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              管辖点位
            </div>
            <a-input placeholder="Basic usage" />
          </div> -->
          <!-- <div style="width:40%;margin:10px 0">
            <div class="boy_top">
              最新刷卡时间
            </div>
            <a-input placeholder="Basic usage" />
          </div> -->
        </div>
      </div>
    </div>
    <div style="    text-align: center;    padding: 50px 0;" @click="goTo">
      <a-button type="primary">
        返回
      </a-button>
    </div>
  </div>
</template>

<script>
import { getCreditCardInfoDetail } from '@/api/member'
import {
  indexPageUserInfo
} from '@/api/workBench'
export default {
  data () {
    return {
      listNum: {},
      name: this.$route.query.name,
      info: {}
    }
  },
  mounted () {
    const id = this.$route.query.id
    this.getRoleList(id)
  },
  methods: {
    getRoleList (val) {
      const params = {
        id: val
      }

      this.loading = true
      getCreditCardInfoDetail(params).then(res => {
        this.loading = false
        this.listNum = res.result
      })
    },
    getUserInfo () {
      indexPageUserInfo().then(res => {
        this.info = res.result
      })
    },
    goTo () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .ant-layout-content {
    background: #fff;
  }
  .boy_top {
    padding-bottom: 10px;
  }
</style>
